// Native
import { useState } from "react"

// Components
import { ButtonGroup, Td, Tr } from "@chakra-ui/react"
import { Dash, Section, IconButton, Table, Scope } from "components"

// Screens
import Delete from "./delete"

export default function Banks({ data, refetch, ...props }){

    const [ bank_account, setBank ] = useState(false)

    const columns = [
        { children: 'Banco' }, 
        { children: 'Titular' }, 
        { children: 'Agência' }, 
        { children: 'Conta' }, 
        { children: 'PIX' }, 
        { isNumeric: true }
    ]

    return(
    <>
        <Section title="Contas bancárias do consultor" />
        
        <Table columns={columns} children={ data?.customer?.bank_accounts?.map(item => <Item key={item.id} data={item} onDelete={setBank} />)} />

        <Delete isOpen={!!bank_account} onClose={() => setBank(false)} data={{ bank_account, consultant: data }} onSuccess={refetch}  />
    </>
    )
}

const Item = ({ data:item, onDelete, ...props }) => (
    <Tr {...props}>
        <Td children={item?.bank?.name ?? <Dash />} />
        <Td textTransform="capitalize" children={item.name} />
        <Td children={<Dash children={item.agency} />} />
        <Td children={<Dash children={item.account} />} />
        <Td children={<Dash children={item.pix_key} />} />
        <Td>
            <ButtonGroup size="xs" variant="outline">
                <Scope role="manage_consultants"><IconButton colorScheme="red" icon="trash" onClick={() => onDelete(item)} /></Scope>
            </ButtonGroup>
        </Td>
    </Tr>
)